import ChevronRight from '@mui/icons-material/ChevronRight';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import EntriesLabel from "./DatatableComponents/EntriesLabel";
import { Col, Row } from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';

const DatatablePagination = (
    {totalEntries, rangeStart, rangeEnd, currentPage, numPages, handlePageChange}
) => {

    //console.log("TOTAL ENTRIES - " + totalEntries)
    //console.log("numpages " + numPages);
    var numPagesArr=[];
    for(var x = 2 ; x<numPages ; x++){
        numPagesArr.push(x);
    }

    return(
    <Row className="mt-3 pagination-row">
        <Col lg="4" sm="auto" className="ms-lg-1 ms-sm-auto me-sm-auto">
            <EntriesLabel total={totalEntries} rangeStart={rangeStart} rangeEnd={rangeEnd}></EntriesLabel>
        </Col>
        <Col lg="auto"  className="ms-lg-auto me-lg-0 ms-auto me-auto col-auto">
            <Pagination className="pe-lg-2 d-md-flex d-none">
            {currentPage==1 || totalEntries<1
                ?   <Pagination.Item className="paginationPreviousItem" disabled ><div className="d-flex align-items-center"><ChevronLeft fontSize="small"></ChevronLeft></div>Previous</Pagination.Item> 
                :   <Pagination.Item onClick={()=> handlePageChange(currentPage-1)} className="paginationPreviousItem">
                        <div className="d-flex align-items-center">
                            <ChevronLeft fontSize="small"></ChevronLeft>
                        </div>Previous
                    </Pagination.Item>
            }
            {numPages>=1 ?
                <>
                    <Pagination.Item active={currentPage == 1 ? true: false} onClick={()=> handlePageChange(1)} className="paginationNumItem">{1}</Pagination.Item>
                    {numPages<=6?
                        numPagesArr.map((v) => 
                            <Pagination.Item active={currentPage == v ? true: false} onClick={()=> handlePageChange(v)} className="paginationNumItem">{v}</Pagination.Item>
                        )
                        :null
                    }
                    {numPages>6 && currentPage<3?
                        <>
                            <Pagination.Item active={currentPage == 2 ? true: false} onClick={()=> handlePageChange(2)} className="paginationNumItem">{2}</Pagination.Item>
                            <Pagination.Item active={currentPage == 3 ? true: false} onClick={()=> handlePageChange(3)} className="paginationNumItem">{3}</Pagination.Item>
                            <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>
                        </>
                        :null
                    } 
                    {numPages>6 && currentPage==3?
                        <>
                            <Pagination.Item active={currentPage == 2 ? true: false} onClick={()=> handlePageChange(2)} className="paginationNumItem">{2}</Pagination.Item>
                            <Pagination.Item active={currentPage == 3 ? true: false} onClick={()=> handlePageChange(3)} className="paginationNumItem">{3}</Pagination.Item>
                            <Pagination.Item active={currentPage == 4 ? true: false} onClick={()=> handlePageChange(4)} className="paginationNumItem">{4}</Pagination.Item>
                            <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>
                        </>
                        :null
                    } 
                    {numPages>6 && currentPage>3 && currentPage < numPages-1?
                        <>
                        <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>
                        {currentPage < numPages-1 ? <Pagination.Item onClick={()=> handlePageChange(currentPage-1)} className="paginationNumItem">{currentPage-1}</Pagination.Item>: null}
                        <Pagination.Item active onClick={()=> handlePageChange(currentPage)} className="paginationNumItem">{currentPage}</Pagination.Item>
                        <Pagination.Item onClick={()=> handlePageChange(currentPage+1)} className="paginationNumItem">{currentPage+1}</Pagination.Item>

                        {currentPage < numPages-2 ? 
                            <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>:null
                        }
                        </>
                        :null
                    } 
                    {numPages>6 && currentPage>3 && currentPage > numPages-2 ?
                        <>
                        <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>
                        <Pagination.Item active={currentPage == numPages-2 ? true: false} onClick={()=> handlePageChange(numPages-2)} className="paginationNumItem">{numPages-2}</Pagination.Item>
                        <Pagination.Item active={currentPage == numPages-1 ? true: false} onClick={()=> handlePageChange(numPages-1)} className="paginationNumItem">{numPages-1}</Pagination.Item>
                        
                        </>
                        :null
                    } 
                    {/*numPages>6 && currentPage>3 && currentPage > numPages-3 ?
                        <>
                        <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>
                        <Pagination.Item active={currentPage == numPages-3 ? true: false} onClick={()=> handlePageChange(numPages-3)} className="paginationNumItem">{numPages-3}</Pagination.Item>
                        <Pagination.Item active={currentPage == numPages-2 ? true: false} onClick={()=> handlePageChange(numPages-2)} className="paginationNumItem">{numPages-2}</Pagination.Item>
                        <Pagination.Item active={currentPage == numPages-1 ? true: false} onClick={()=> handlePageChange(numPages-1)} className="paginationNumItem">{numPages-1}</Pagination.Item>
                        
                        </>
                        :null
                */} 

                    {numPages>1 ?
                        <Pagination.Item active={currentPage == numPages ? true: false} onClick={()=> handlePageChange(numPages)} className="paginationNumItem">{numPages}</Pagination.Item>:null
                    }
                    {currentPage==numPages
                        ? <Pagination.Item disabled className="paginationNextItem">Next<div className="d-flex align-items-center"><ChevronRight fontSize="small"></ChevronRight></div></Pagination.Item> 
                        : <Pagination.Item onClick={()=> handlePageChange(currentPage+1)} className="paginationNextItem">Next<div className="d-flex align-items-center"><ChevronRight fontSize="small" ></ChevronRight></div></Pagination.Item>
                    }
                    
                </>
                :null
            }
            </Pagination>

            <Pagination className="d-md-none d-flex flex-sm-row flex-column pe-0 ps-0">
            {currentPage==1 
                ? <Pagination.Item className="paginationPreviousItem" disabled ><div className="d-flex align-items-center"><ChevronLeft fontSize="small"></ChevronLeft></div>Previous</Pagination.Item> 
                : <Pagination.Item onClick={()=> handlePageChange(currentPage-1)} className="paginationPreviousItem"><div className="d-flex align-items-center"><ChevronLeft fontSize="small"></ChevronLeft></div>Previous</Pagination.Item>}
            {numPages>=1 ?
                <>
                <Pagination.Item active={currentPage == 1 ? true: false} onClick={()=> handlePageChange(1)} className="paginationNumItem">{1}</Pagination.Item>
                {numPages<=6?
                    numPagesArr.map((v) => 
                    <Pagination.Item active={currentPage == v ? true: false} onClick={()=> handlePageChange(v)} className="paginationNumItem">{v}</Pagination.Item>
                    )
                    :null
                }
                {numPages>6 && currentPage<=2?
                    <>
                    <Pagination.Item active={currentPage == 2 ? true: false} onClick={()=> handlePageChange(2)} className="paginationNumItem">{2}</Pagination.Item>
                    
                    <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>
                    </>
                    :null
                } 
                {numPages>6 && currentPage>2 && currentPage <= numPages-1?
                    <>
                    <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>
                    
                    <Pagination.Item active onClick={()=> handlePageChange(currentPage)} className="paginationNumItem">{currentPage}</Pagination.Item>


                    {currentPage < numPages-1 ? 
                        <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>:null
                    }
                    </>
                    :null
                } 
                {numPages>6 && currentPage>2 && currentPage > numPages-1?
                    <>
                    <Pagination.Ellipsis className="ellipsis" tabIndex="-1"/>
                    
                    <Pagination.Item active={currentPage == numPages-1 ? true: false} onClick={()=> handlePageChange(numPages-1)} className="paginationNumItem">{numPages-1}</Pagination.Item>
                    
                    </>
                    :null
                } 

                {numPages>1 ?
                    <Pagination.Item active={currentPage == numPages ? true: false} onClick={()=> handlePageChange(numPages)} className="paginationNumItem">{numPages}</Pagination.Item>:null
                }
                {currentPage==numPages 
                    ? <Pagination.Item disabled className="paginationNextItem">Next<div className="d-flex align-items-center"><ChevronRight fontSize="small"></ChevronRight></div></Pagination.Item> 
                    : <Pagination.Item onClick={()=> handlePageChange(currentPage+1)} className="paginationNextItem">Next<div className="d-flex align-items-center"><ChevronRight fontSize="small" ></ChevronRight></div></Pagination.Item>}
                
                </>
                :null
            }
            </Pagination>
        </Col> 
    </Row>
  );
}

export default DatatablePagination;